export const KNOWN_VOCATIONS = {
  CNA: "cld0rqgmb000e2qs3hgj6fpvl",
  CPR: "cld0rqgmb000g2qs31hpr1ul0",
  PHLEBOTOMY: "cld0rqgmc00102qs3912303vk",
  MEDICAL_ASSISTANT: "cld0rqgma000b2qs336aj19o5",
  PHARMACY_TECH: "cld0rqgmc000z2qs3aywqdqt5",
  EKG: "cld0rqgmb000m2qs3b0yy5uk6",
  HHA: "cld0rqgmb000o2qs3cfj09bla",
  PCT: "cld0rqgmc000x2qs3fi3f1zr2",
  MEDICAL_BILLING_CODING: "cld0rqgmb000u2qs3deiggekq",
  OPERATOR: "cldv3au1w2ke63drac3ytey7n",
  MEDICAL_ADMINISTRATIVE_ASSISTANT: "cld0rqgmb000s2qs30spcbfsz",
  MEDICAL_TRANSCRIPTIONIST: "cllwvvtdb0rbn3jq22d3xbnxy",
  HEALTHCARE_DOCUMENTATION_SPECIALIST: "cllwvnnh40qkj3jq2ej6h32vp",
  RADIOLOGY_TECHNICIAN: "cli2bzrn939fd3dpbapji5u87",
  HIGH_SCHOOL_DIPLOMA: "clvzu1zyt1glh2xsj3b7n2zfb",
};

export const RANKED_HEALTH_VOCATIONS = [
  KNOWN_VOCATIONS.CNA,
  KNOWN_VOCATIONS.PHLEBOTOMY,
  KNOWN_VOCATIONS.MEDICAL_ASSISTANT,
  KNOWN_VOCATIONS.PHARMACY_TECH,
  KNOWN_VOCATIONS.EKG,
  KNOWN_VOCATIONS.PCT,
  KNOWN_VOCATIONS.MEDICAL_BILLING_CODING,
];
